import axios from "axios";
import { boundsToPolygon, polygonToGoogleMapBounds } from "./utils";
import { api_url } from "../config";

const base_url = api_url;
export const publishCity = async data => {
  const { cityBounds, newCityName, toPublishFence } = data;
  const bounds = boundsToPolygon(cityBounds);
  const name = newCityName;

  const geofence = {
    ...toPublishFence,
    properties: {
      ...toPublishFence.properties,
      cityName: name,
      name
    }
  };
  const city = {
    name,
    bounds
  };
  return axios.post(
    `${base_url}/geofence/city`,
    {
      city,
      geofence
    },
    {
      withCredentials: true
    }
  );
};

export const loadCity = async cityName => {
  const response = await axios.get(`${base_url}/geofence`, {
    params: {
      cityName
    },
    withCredentials: true
  });
  const { geofences, cityBounds, availableCities } = response.data;
  const bounds = polygonToGoogleMapBounds(cityBounds);
  return {
    geofences,
    bounds,
    availableCities
  };
};

export const publishGeofence = async data => {
  const { cityName, toPublishFence } = data;

  const geofence = {
    ...toPublishFence,
    properties: {
      ...toPublishFence.properties,
      cityName
    }
  };
  return axios.post(
    `${base_url}/geofence`,
    {
      geofence
    },
    {
      withCredentials: true
    }
  );
};

export const updateGeofence = async geofence => {
  return axios.put(
    `${base_url}/geofence`,
    {
      geofence
    },
    {
      withCredentials: true
    }
  );
};

export const deleteGeofence = async geofence => {
  return axios.delete(`${base_url}/geofence`, {
    params: {
      geofenceCategory: geofence.properties.fenceCategory,
      geofenceId: geofence._id
    },
    withCredentials: true
  });
};
export const loadAvailableCitiesList = async () => {
  return axios.get(`${base_url}/geofence/city`, {
    withCredentials: true
  });
};

export const loadOrderLocs = async (cityName, dateRange) => {
  let params = {
    cityName
  };
  if (dateRange && dateRange.length === 2) {
    params = {
      ...params,
      toDate: dateRange[1],
      fromDate: dateRange[0]
    };
  }
  const response = await axios.get(`${base_url}/geofence/orderPins`, {
    params,
    withCredentials: true
  });
  return response;
};

export const updateWarehousesOfGeofence = async geofence => {
  return axios.put(
    `${base_url}/geofence/warehouses`,
    {
      geofence
    },
    {
      withCredentials: true
    }
  );
};
